import React from 'react'
import { Redirect, Route } from 'react-router-dom'

import { useAuth } from '../../auth/AuthProvider'

// WONE-568: gate protected routes by the AuthProvider state. While
// bootstrap is still in flight (refresh round-trip) we render nothing
// to avoid a flash of the login page for users with a valid cookie
// session. The bootstrap call resolves either way so this is bounded.
const Protected = ({ component: Cmp, ...rest }) => {
  const { authed, bootstrapped } = useAuth()
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!bootstrapped) return null
        if (authed) return <Cmp {...props} />
        return (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }}
    />
  )
}

export default Protected
